__turbopack_context__.v({
  "contentWrapper": "successOverlay-module-scss-module__BuRsFq__contentWrapper",
  "succeedSubmit": "successOverlay-module-scss-module__BuRsFq__succeedSubmit",
  "successOverlay": "successOverlay-module-scss-module__BuRsFq__successOverlay",
  "successSubmitContainer": "successOverlay-module-scss-module__BuRsFq__successSubmitContainer",
});
